import './draft-form-reset-button.scss';

import { useEffect, useState } from 'react';

import { CustomModal } from '@/components/Shared/Modal/CustomModal';
import { Button } from '@/components/Shared/ui';
import { useAppSelector } from '@/store';

import { getLeasingDraftKey } from '../../helpers';

const DraftFormResetButton = () => {
  const { request } = useAppSelector((state) => state.ieLeasingOrder);

  const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);
  const [isUserHasUnsavedData, setIsUserHasUnsavedData] = useState(false);

  const handleDraftClear = () => {
    if (!request) return;
    setIsConfirmModalOpen(false);
    sessionStorage.removeItem(getLeasingDraftKey(request.uuid));
    window.location.reload();
  };

  useEffect(() => {
    if (!request) return;
    const unsavedData = sessionStorage.getItem(
      getLeasingDraftKey(request.uuid)
    );
    setIsUserHasUnsavedData(!!unsavedData);
    return () => {
      setIsUserHasUnsavedData(false);
    };
  }, [request]);

  if (!isUserHasUnsavedData) return null;
  return (
    <>
      <div className="ie-draft-form-reset-button">
        <span className="ie-draft-form-reset-button__text">
          Некоторые поля заполнены автоматически из ранее сохранённых данных
        </span>
        <Button
          type="button"
          variant="outlined-red"
          size="small"
          onClick={() => setIsConfirmModalOpen(true)}
        >
          Сбросить
        </Button>
      </div>

      <CustomModal
        editClass="ie-draft-form-reset-button__confirm-modal"
        isModalOpen={isConfirmModalOpen}
        handleCancel={() => setIsConfirmModalOpen(false)}
        handleOk={handleDraftClear}
        title="Сбросить сохранённые данные формы?"
        footer={[
          <Button key="back" onClick={() => setIsConfirmModalOpen(false)}>
            Отмена
          </Button>,
          <Button
            key="submit"
            variant="filled-red"
            onClick={() => {
              handleDraftClear();
              setIsConfirmModalOpen(false);
            }}
          >
            Да, сбросить
          </Button>
        ]}
      >
        <span className="ie-draft-form-reset-button__confirm-modal-description">
          Все несохранённые данные будут удалены, а страница — перезагружена.
          Это действие нельзя отменить.
        </span>
      </CustomModal>
    </>
  );
};

export default DraftFormResetButton;
